"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveEventStreamSerdeConfig = void 0;
var event_streams_1 = require("@smithy/core/event-streams");
Object.defineProperty(exports, "resolveEventStreamSerdeConfig", { enumerable: true, get: function () { return event_streams_1.resolveEventStreamSerdeConfig; } });
